import { render, staticRenderFns } from "./userPrivate.vue?vue&type=template&id=6fe8fa08&scoped=true&"
import script from "./userPrivate.vue?vue&type=script&lang=js&"
export * from "./userPrivate.vue?vue&type=script&lang=js&"
import style0 from "./userPrivate.vue?vue&type=style&index=0&id=6fe8fa08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe8fa08",
  null
  
)

export default component.exports